import { Box } from "@mui/material";
import * as React from "react";

const Topbar = () => {
  return (
    <Box display="flex" justifyContent="right" p={2}>
      {/* ICONS */}
      <Box display="flex"></Box>
    </Box>
  );
};

export default Topbar;
